import axios from 'axios';
import { variablesGlobales } from '../../configs/variables';

export class ToggleApiPaymentsService {



    static async getData() {
        try {
            const responseServer = await axios.get(`${variablesGlobales.urlServiceBackend}/api/v1/toggle-api-payments/find`);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response?.data?.message ?? error.message,
                date: new Date(),
                code: error.code,
                status: error?.response?.status
            }
        }
    }

}